/**
 * 场景状态机：游戏由若干场景（title/charSelect/game/result/leaderboard）组成。
 * 场景接口：{ enter(params), exit(), update(dt), draw(renderer) }。
 * 切换通过 scene.switchTo(name, params)，本帧末生效，避免遍历中改状态。
 */
export class SceneManager {
  constructor() {
    /** @type {Map<string, object>} */
    this.scenes = new Map();
    this.current = null;
    this.currentName = null;
    this._pending = null;
    /** 跨场景共享上下文（ assets / audio / renderer / 战绩等 ），由 main.js 注入 */
    this.shared = {};
  }

  /** @param {string} name @param {object} scene */
  register(name, scene) {
    this.scenes.set(name, scene);
  }

  /** 请求切换场景（延迟到本帧 update 末尾执行）。 */
  switchTo(name, params = {}) {
    this._pending = { name, params };
  }

  _applyPending() {
    if (!this._pending) return;
    const { name, params } = this._pending;
    this._pending = null;
    const next = this.scenes.get(name);
    if (!next) throw new Error(`未知场景: ${name}`);
    this.current?.exit?.();
    // enter 成功后才提交 current/currentName：否则 enter 抛异常会把管理器
    // 指向半初始化场景、后续每帧 update 继续抛（历史 bug：损坏录像可致假死）
    try {
      next.enter?.(params);
    } catch (e) {
      console.error(`[sceneManager] ${name}.enter 失败，回退标题:`, e);
      try { next.exit?.(); } catch (e3) { /* 清理半成品副作用失败不阻塞回退 */ }
      const fallback = this.scenes.get('title');
      if (fallback && next !== fallback) {
        try { fallback.enter?.(); this.current = fallback; this.currentName = 'title'; } catch (e2) { /* 标题也炸则保持现状 */ }
      }
      return;
    }
    this.current = next;
    this.currentName = name;
  }

  /** @param {number} dt */
  update(dt) {
    this.current?.update?.(dt);
    this._applyPending();
  }

  /** @param {object} renderer */
  draw(renderer) {
    this.current?.draw?.(renderer);
  }
}
